import React from "react";
import withStyles from "react-jss";

const styles = (theme) => ({
	root: {
		display: "flex",
		alignItems: "center",
		flexWrap: "wrap",
		marginBottom: "-30px",
	},
	item: {
		marginRight: "30px",
		marginBottom: "30px",
		"&:last-child": {
			marginRight: 0,
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			flexDirection: "column",
			alignItems: "flex-start",
			marginBottom: 0,
		},
		item: {
			marginRight: 0,
			marginBottom: "16px",
			"&:last-child": {
				marginBottom: 0,
			},
		},
	},
});

class MultiCheckboxLayout extends React.Component {
	render() {
		let classes = this.props.classes;
		return (
			<div className={classes.root}>
				{React.Children.map(this.props.children, (item, index) => {
					return (
						<div className={classes.item} key={index}>
							{item}
						</div>
					);
				})}
			</div>
		);
	}
}

export default withStyles(styles)(MultiCheckboxLayout);
